<script>
  let { label, children, visible = $bindable(true) } = $props()
</script>

<div class="contents">

  <div class="flex items-center relative col-span-12 w-[102%] mx-[-1%]" onclick={() => visible = !visible} aria-label={`Toggle ${label} section`}>
    <mark class="p-2 bg-transparent ml-3 text-xs text-gray-500 z-[2] cursor-pointer" class:opacity-50={!visible}>{label}</mark>
    <span class="absolute left-0 bg-gray-200/80 w-full h-px"></span>
  </div>
  
  <div class="contents" class:hidden={!visible}>
    {@render children?.()}
  </div>
</div>